import { appInsightsCore } from "../../AppInsights";

export const trackEvent = (eventName, properties, measurements) => {
  if (appInsightsCore?.trackEvent) {
    const eventData = {
      name: eventName,
      properties: {
        eventName,
        timestamp: new Date().toISOString(),
        ...properties,
      },
      measurements,
    };
    appInsightsCore.trackEvent(eventData);
  }
};

export const trackException = (exception, properties) => {
  if (appInsightsCore?.trackException) {
    const exceptionData = {
      exception,
      properties: {
        ...properties,
        timestamp: new Date().toISOString(),
      },
    };
    appInsightsCore.trackException(exceptionData);
  }
};

export const trackMetric = (name, value, properties) => {
  if (appInsightsCore?.trackMetric) {
    const metricData = {
      name,
      average: value,
      properties,
    };
    appInsightsCore.trackMetric(metricData);
  }
};

export { appInsightsCore as appInsights };
